<div>
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">{{"schedule" | translate}}</h5>
            <h6 class="card-subtitle text-muted"></h6>
        </div>
        <div class="card-body">
                <div class="conn mb-4" *ngFor="let conn of connectors">
                    <h4 class="">{{conn.name.startsWith('mennekes') ? 'Tipo-2' : 'Schuko'}}</h4>

                    <!-- Cards Container -->
                    <div class="cards-container">

                      <!-- No tasks - Show 24/7 active card -->
                      <div *ngIf="tasks['timeTasks'][conn.name] && tasks['timeTasks'][conn.name].length == 0" class="schedule-card default-card">


                        <!-- <div class="d-flex justify-content-center align-items-center  "> -->
                          <div class="default-label-container d-flex justify-content-center align-items-center">
                            <span class="no-schedule-text">{{ 'NoScheduledTimes' | translate }}</span>
                          </div>
                        <!-- </div> -->

                      </div>

                      <!-- Task Cards -->
                      <div *ngFor="let task of tasks['timeTasks'][conn.name]; let i = index" class="border border-light rounded p-1">

                        <div class="d-flex justify-content-between align-items-center  ">

                          <div class="toggle-container">
                            <label class="toggle-switch">
                              <input type="checkbox" [checked]="task.active==1" (click)="task.active==1 ? task.active=0 : task.active=1">
                              <span class="toggle-slider"></span>
                            </label>
                          </div>

                          <div class="ms-3 fs-5 fw-bold text-dark text-center">
                            {{ _utils.getDateFromMinutes(task?.initTime?.timeList[0]?.hourMin) }} -
                            {{ _utils.getDateFromMinutes((task?.initTime?.timeList[0]?.hourMin + task?.initTime?.timeList[0]?.duration) % 1440  ) }}
                          </div>

                          <div class="schedule-info">
                            <!-- <div class="time-range-display">
                                                      {{ _utils.getDateFromMinutes(task?.initTime?.timeList[0]?.hourMin) }} -
                                                      {{ _utils.getDateFromMinutes(task?.initTime?.timeList[0]?.hourMin + task?.initTime?.timeList[0]?.duration) }}
                                                    </div> -->
                            <div *ngIf="task.type != 1" class="days-row">
                              <div *ngFor="let day of daysOfWeek" [ngClass]="{
                                                             'day-badge': true,
                                                             'day-selected':  _utils.setDaysFromBitmask(task.initTime.weekday)[day.value]
                                                           }">
                                {{ day.label | translate }}
                              </div>
                            </div>
                          </div>

                          <div class="action-buttons">
                            <button class="btn-action btn-edit" (click)="openEditTask(task)">
                              <i class="fas fa-edit" style="font-size: 15px;"></i>
                            </button>
                            <button class="btn-action btn-delete" (click)="deleteTask(task.id, conn.name)">
                              <i class="fas fa-trash-alt" style="font-size: 15px;"></i>
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>

                <div class="w-100 d-flex justify-content-center mt-3 ">
                    <button class="btn btn-light mx-2" (click)="openAddTask(conn.name)">
                      {{"addNew" | translate}}
                    </button>

                    <button class="btn btn-primary mx-2" (click)="save(conn.name)">
                      {{"save" | translate}}
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error[conn.name]!=''">
                    <div class="alert-message">
                        {{ error }}
                    </div>
                </div>
                <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage[conn.name]">
                    <div class="alert-message">
                        {{"updatedSuccesfully" | translate}}
                    </div>
                </div>
                </div>

        </div>

    </div>
</div>

<!-- Modal de advertencia de solapamiento -->
<div class="modal fade" [class.show]="showWarningModal" [style.display]="showWarningModal ? 'block' : 'none'" tabindex="-1" role="dialog" *ngIf="showWarningModal">
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-exclamation-triangle text-warning me-2"></i>
          {{ 'warning' | translate }}
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ warningMessage }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancelOverlap()">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-warning" (click)="confirmOverlap()">
          {{ 'continue' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal -->
<div class="modal-backdrop fade" [class.show]="showWarningModal" *ngIf="showWarningModal" (click)="cancelOverlap()"></div>
